<template>
	<button
		class="button account__payments__submit"
		:loading="loading"
		@click="$emit('click')"
	>
		<span class="button__loader" v-if="loading"></span>
		<span v-else-if="title">{{ title }}</span>
		<slot />
	</button>
</template>

<script>
export default {
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			required: false,
		},
	},
	mounted() {
		this.$emit("mounted");
	},
};
</script>
